import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import {
  Dropdown,
  DropdownContent,
  DropdownGroup,
  DropdownTextInput,
  EmptyState,
  Scrollbar,
  Typography,
  Error,
} from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { makeTextFieldClear, makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { type TransferConversationModalStore } from 'widgets/TransferConversationModal/store/transferConversationModalStore'

import styles from '../styles.module.scss'

export interface IOrganizationsDropdownProps {
  store: TransferConversationModalStore
}
export const OrganizationsDropdown: FC<IOrganizationsDropdownProps> = observer(({ store }) => {
  const {
    searchOrganization,
    setSearchOrganization,
    organizationsDropdownItems,
    setActiveOrganizationId,
    activeOrganization,
    isEmptyOrganizationsDropdown,
    organizationError,
  } = store

  const TriggerComponent = () => {
    return (
      <>
        <TextFieldPlaceholder
          rightActions={[
            makeTextFieldIcon({
              icon: 'chevronDown',
              className: styles.iconAction,
            }),
          ]}
          placeholder={
            <Typography
              variant={'text-input-field-r'}
              color={
                activeOrganization
                  ? 'var(--content-primary-primary)'
                  : 'var(--content-neutral-primary)'
              }
              ariaLabel={'organizationTriggerValue'}
            >
              {activeOrganization ? activeOrganization.name : 'Select'}
            </Typography>
          }
          className={classNames(styles.textField, {
            [styles.empty]: !activeOrganization,
            [styles.error]: !!organizationError,
          })}
          variant={'stroke'}
          size={'medium'}
        />
        <Error type={'text'} error={organizationError} />
      </>
    )
  }
  return (
    <div className={styles.wrapDropdown}>
      <Label
        label={{
          text: 'Select organization',
        }}
        marginBottom={4}
      />
      <Dropdown
        width={432}
        ariaLabel={'organizationsDropdown'}
        triggerComponent={TriggerComponent}
        customComponent={(onClose) => {
          return (
            <DropdownContent noPadding>
              <DropdownTextInput
                textFieldProps={{
                  onChange: setSearchOrganization,
                  value: searchOrganization,
                  InputProps: {
                    placeholder: 'Search',
                  },
                  rightActions: [makeTextFieldClear()],
                }}
              />
              <Scrollbar autoHeight autoHeightMin={0} autoHeightMax={160}>
                {isEmptyOrganizationsDropdown ? (
                  <EmptyState noIcon boxProps={{ height: 41 }} />
                ) : (
                  <DropdownGroup
                    key={'organizations'}
                    items={organizationsDropdownItems}
                    isScroll={false}
                    onChange={(value) => {
                      setActiveOrganizationId(value.id)
                      onClose()
                    }}
                  />
                )}
              </Scrollbar>
            </DropdownContent>
          )
        }}
      />
    </div>
  )
})
